import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const formatter = new Intl.DateTimeFormat("en-GB", {
	dateStyle: "long",
	// timeStyle: "long",
	timeZone: "Australia/Sydney",
});
